import { getTaxRateById } from "../../data/taxRates";

export const computeLineVat = (lineTotalTTC, ratePercent) => {
  const ttc = Number(lineTotalTTC || 0);
  const rate = Number(ratePercent || 0);
  return Number(((ttc * rate) / (100 + rate)).toFixed(2));
};

export const computeTicketTotals = (items, costMap, taxRates) => {
  const safeItems = Array.isArray(items) ? items : [];
  const safeRates = Array.isArray(taxRates) ? taxRates : [];
  const map = costMap instanceof Map ? costMap : new Map();

  let grandTotal = 0;
  let vatTotal = 0;
  let purchaseTotal = 0;
  let knownCount = 0;
  let missingRateWarned = false;

  safeItems.forEach((item) => {
    const lineTotal = Number(item.lineTotal || 0);
    grandTotal += lineTotal;

    const taxId = item.product && item.product.tax_rate_id;
    const rateInfo = taxId ? getTaxRateById(safeRates, taxId) : null;
    if (rateInfo) {
      vatTotal += computeLineVat(lineTotal, rateInfo.rate);
    } else if (!missingRateWarned) {
      console.warn(
        "[caisse] Ligne(s) sans taux de TVA reconnu (tax_rate_id manquant ou inconnu): TVA comptee a 0 pour ces lignes."
      );
      missingRateWarned = true;
    }

    const productId = item.product && item.product.id;
    const costEntry = productId ? map.get(productId) : null;
    const unitCost = costEntry ? Number(costEntry.unitCost || 0) : Number(item.product?.purchasePrice || 0);
    
    if (unitCost > 0 || costEntry) {
      knownCount += 1;
      purchaseTotal += unitCost * Number(item.quantity || 0);
    }
  });

  purchaseTotal = Number(purchaseTotal.toFixed(2));
  vatTotal = Number(vatTotal.toFixed(2));

  return {
    count: safeItems.length,
    grandTotal: Number(grandTotal.toFixed(2)),
    vatTotal,
    purchaseTotal,
    knownCount,
    margin: knownCount > 0 ? Number(((grandTotal - vatTotal) - purchaseTotal).toFixed(2)) : null,
  };
};
